module.exports = __webpack_public_path__ + "static/img/zhong19.f703d23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong19.png
// module id = gbnj
// module chunks = 16